import { useState, useEffect } from 'react';
import Modal from '@/core/Modal';

const CHANGELOG_VERSION = '1.2.1';
const STORAGE_KEY = `changelog_${CHANGELOG_VERSION}_seen`;

const changelogItems = [
  {
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.40991 22C3.40991 18.13 7.25991 15 11.9999 15"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22 21C22 19.3431 20.6569 18 19 18C17.3431 18 16 19.3431 16 21"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19 14C19.5523 14 20 13.5523 20 13C20 12.4477 19.5523 12 19 12C18.4477 12 18 12.4477 18 13C18 13.5523 18.4477 14 19 14Z"
          fill="currentColor"
        />
      </svg>
    ),
    text: 'اضافه شدن قابلیت تغییر نام کاربری',
    category: 'feature',
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path d="M12 6V12L16 14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    text: 'اضافه شدن حالت تاریک (دارک مود)',
    category: 'feature',
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="3" y="3" width="18" height="18" rx="3" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="9" cy="9" r="2" fill="currentColor" />
        <path
          d="M21 15L16 10L12 14L9 11L3 17"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    text: 'اضافه شدن قابلیت کراپ عکس پروفایل',
    category: 'improvement',
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="4" width="20" height="16" rx="2" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="8" cy="10" r="2" fill="currentColor" />
        <path d="M14 18L22 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
    text: 'اضافه شدن دابز استودیو',
    category: 'feature',
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9 11L12 14L22 4"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21 12V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H16"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    text: 'اضافه شدن قابلیت خاموش کردن تخمین قیمت اگهی',
    category: 'improvement',
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="1.5" />
        <path d="M9 9H15M9 12H15M9 15H12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
    text: 'اضافه شدن قابلیت کارت دیجیتال مشاور',
    category: 'feature',
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="1.5" />
        <path d="M9 9H15M9 12H15M9 15H12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
    text: 'اضافه شدن قابلیت ساخت کارت دیجیتال املاک',
    category: 'feature',
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9 12L11 14L15 10"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    ),
    text: 'رفع باگ های گزارش شده',
    category: 'fix',
  },
];

// eslint-disable-next-line react/prop-types
export default function ChangelogModal({ forceShow = false }) {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // حذف notification های قدیمی از localStorage
    // فقط notification جدید را نگه دار
    const allKeys = Object.keys(localStorage);
    allKeys.forEach((key) => {
      if (key.startsWith('changelog_') && key.endsWith('_seen') && key !== STORAGE_KEY) {
        localStorage.removeItem(key);
      }
    });

    // اگر forceShow فعال باشد، همیشه نمایش بده
    if (forceShow) {
      setTimeout(() => {
        setIsOpen(true);
      }, 1000);
      return;
    }

    // بررسی اینکه آیا این changelog قبلاً نمایش داده شده یا نه
    const hasSeen = localStorage.getItem(STORAGE_KEY);

    if (!hasSeen) {
      // کمی تاخیر برای نمایش بهتر
      setTimeout(() => {
        setIsOpen(true);
      }, 1000);
    }
  }, [forceShow]);

  const handleClose = () => {
    setIsOpen(false);
    // ذخیره در localStorage که این changelog دیده شده است (فقط اگر forceShow فعال نباشد)
    if (!forceShow) {
      localStorage.setItem(STORAGE_KEY, 'true');
    }
  };

  if (!isOpen) return null;


  return (
    <Modal
      onOpenChange={handleClose}
      width="850"
      className="max-w-[95vw] max-h-[95vh] overflow-hidden custom-scrollbar"
    >
      <div className="w-full relative flex flex-col h-full">
        {/* Header Section with Gradient Background */}
        <div className="relative overflow-hidden bg-primary">
          {/* Animated Background Elements */}
          <div className="absolute inset-0 overflow-hidden">
            {/* Moving Circles */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full blur-3xl animate-pulse"></div>
            <div className="absolute bottom-0 left-0 w-80 h-80 bg-white/8 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-white/5 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '2s' }}></div>
            
            {/* Floating Shapes */}
            <div className="absolute top-10 right-20 w-32 h-32 bg-white/10 rounded-3xl blur-2xl animate-bounce" style={{ animationDuration: '6s', animationDelay: '0s' }}></div>
            <div className="absolute bottom-10 left-20 w-24 h-24 bg-white/12 rounded-2xl blur-xl animate-bounce" style={{ animationDuration: '8s', animationDelay: '1s' }}></div>
            <div className="absolute top-20 left-1/3 w-20 h-20 bg-white/8 rounded-full blur-xl animate-bounce" style={{ animationDuration: '7s', animationDelay: '2s' }}></div>
            
            {/* Gradient Waves */}
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent animate-shimmer"></div>
          </div>

          <div className="relative z-10 p-4 pb-3">
            {/* Close Button */}
            <button
              onClick={handleClose}
              className="absolute top-3 left-3 px-3 py-1 bg-white/10 hover:bg-white/20 backdrop-blur-sm rounded-md transition-all z-50 text-white font-medium text-xs"
            >
              بستن
            </button>

            {/* Header Content */}
            <div className="flex flex-col items-center text-center mt-2">
              {/* Notification Icon */}
              <div className="mb-2 relative">
                <div className="w-14 h-14 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center border border-white/30">
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="text-white"
                  >
                    <path
                      d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M13.73 21a2 2 0 0 1-3.46 0"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <circle cx="18" cy="6" r="3" fill="#FFD700" stroke="white" strokeWidth="1.5" />
                  </svg>
                </div>
                {/* Pulse Effect */}
                <div className="absolute inset-0 w-14 h-14 rounded-full bg-white/30 animate-ping"></div>
              </div>
              
              <h2 className="text-xl font-bold text-white mb-1">
                به‌روزرسانی جدید
              </h2>
              <span className="px-3 py-1 bg-white/20 backdrop-blur-md text-white rounded-full text-xs font-semibold">
                نسخه {CHANGELOG_VERSION}
              </span>
            </div>
          </div>
        </div>

        {/* Content Section */}
        <div className="flex-1 overflow-y-auto bg-white dark:bg-blackFont-900 px-4 py-3">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
            {changelogItems.map((item, index) => (
              <div
                key={index}
                className="group flex items-center gap-1.5 px-3 py-3.5 rounded-md bg-gray-50 dark:bg-blackFont-800 border border-blackFont-300 dark:border-blackFont-700 hover:bg-primary/5 hover:border-primary/30 dark:hover:bg-primary/10 transition-all duration-200"
                style={{
                  animation: `fadeInUp 0.3s ease-out ${index * 0.05}s both`,
                }}
              >
                {/* Icon */}
                <div className="flex-shrink-0 text-primary opacity-70">
                  {item.icon}
                </div>
                
                {/* Text */}
                <span className="text-sm text-text-normal dark:text-white font-medium truncate">
                  {item.text}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Footer Section */}
        <div className="border-t border-gray-300 dark:border-blackFont-700 bg-white dark:bg-blackFont-900 p-3">
          <button
            onClick={handleClose}
            className="w-full py-2 px-4 bg-primary hover:bg-primary/90 text-white rounded-lg font-medium text-sm transition-colors"
          >
            متوجه شدم
          </button>
        </div>
      </div>
    </Modal>
  );
}

/**
 * ChangelogModal Component
 * @param {Object} props - Component props
 * @param {boolean} [props.forceShow=false] - Force show modal for testing
 */
